<template>
  <section id="admin-filter">
    <h4>GST-VAT Filter</h4>
    <div class="form-group">
      <label class="form-label">Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Location"
        placeHolder="Type to search"
        :initVal="entity.originLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectLocation"
      />
    </div>
    <div class="form-group">
      <label for="service" class="form-label">Service</label>
      <select class="form-control" id="service" v-model="entity.service">
        <option value=""/>
        <option v-for="(opt, i) in serviceTypes" :value="opt.code">{{ opt.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import QuoteTaxMixin from './mixin'
  export default {
    name: 'QuoteTaxFilter',
    mixins: [ FilterMixin, HelperMixin, QuoteTaxMixin ],
    data () {
      return {
        locationSearchText: null,
        entity: {
          service: null,
          originLocation: ''
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectLocation (o) {
        this.entity.location = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/QuoteTax/QuoteTaxFilter.vue